/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './Home24Blog.css';
import RedButton from '@/components/atoms/RedButton';

function Home24Blog() {
  return (
    <>
      <section id="santander-blog">
        <ContainerHome24>
          <div className="santander-blog-contain">
            <h3 className="santander-blog-title">Blog</h3>
            <p className="santander-blog-subtitle">
              Acompanhe as novidades e assuntos da Santander financiamentos.
            </p>
            <a href="blog.html" className="santander-blog-link">
              Ir para o blog
            </a>
            <div className="cards-blog">
              <a
                href="blog/emprestimo-com-garantia-veiculo.html"
                id="novidades-emprestimo-com-garantia-veiculo-saiba-mais"
                className="card-blog"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-74/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-74/capa.png" />
                  <img
                    src="static/amp/blog/post-74/capa.png"
                    alt="Uma mulher de cabelos longos e escuros, usando uma blusa vermelha, sentada no banco do motorista de um carro realizando um empréstimo com garantia de veículo"
                    className="card-blog-img"
                  />
                </picture>
                <p className="card-blog-text">
                  Empréstimo com garantia de veículo: o que é e quais as vantagens?
                </p>
                <p className="card-blog-link">Saiba mais</p>
              </a>
              <a
                href="blog/move-brasil-vale-para-negativados.html"
                id="novidades-move-brasil-vale-para-negativados-saiba-mais"
                className="card-blog"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-81/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-81/capa.png" />
                  <img
                    src="static/amp/blog/post-81/capa.png"
                    alt="Imagem de veículo em atividade na cidade, representando clientes que conquistaram o financiamento do automóvel com a Move Brasil para Negativados na Santander Financiamentos."
                    className="card-blog-img"
                  />
                </picture>
                <p className="card-blog-text">
                  Move Brasil vale para negativados? Entenda as regras do programa
                </p>
                <p className="card-blog-link">Saiba mais</p>
              </a>
              <a
                href="blog/move-brasil-taxi-aplicativo.html"
                id="novidades-move-brasil-taxi-aplicativo-saiba-mais"
                className="card-blog"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-80/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-80/capa.png" />
                  <img
                    src="static/amp/blog/post-80/capa.png"
                    alt="Motorista ao volante em ambiente urbano, representando taxistas e motoristas de aplicativo que contam com o Santander Financiamentos para adquirir ou renovar seu veículo por meio do Programa Move Brasil."
                    className="card-blog-img"
                  />
                </picture>
                <p className="card-blog-text">
                  Move Brasil para Motoristas de Aplicativo e Taxistas: como conseguir o subsídio do
                  governo
                </p>
                <p className="card-blog-link">Saiba mais</p>
              </a>
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default Home24Blog;
